<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<div class="slds-grid slds-wrap">
  <div #chart [id]="id" class="slds-col">
    <div [id]="tooltipId" class="tl-tooltip"></div>
    <div>{{message}}</div>
  </div>

  <div class="slds-col slds-m-top_small tl-right">
    <div class="slds-form-element slds-m-vertical_small">
      <label class="slds-checkbox_toggle slds-grid">
        <span class="slds-form-element__label slds-m-bottom_none">Display Values</span>
        <input (click)="onCumulated($event)" aria-describedby="cumulated-toggle" checked=""
               name="cumulated-toggle"
               type="checkbox" value="cumulated-toggle"/>
        <span aria-live="assertive" class="slds-checkbox_faux_container" id="cumulated-toggle">
          <span class="slds-checkbox_faux"></span>
          <span class="slds-checkbox_on" i18n>Cumulated</span>
          <span class="slds-checkbox_off" i18n>Direct</span>
        </span>
      </label>
    </div>

    <div *ngFor="let legend of legends"
         [style.background]="legend.background" class="tl-legend">
      <span [style.color]="legend.color" class="tl-legend-label">{{legend.label}}:</span>
      <span class="tl-legend-value">{{legend.value}}</span>
      <span class="tl-legend-value-c">{{legend.valueCumulated}}</span>
    </div>
  </div>
</div>


<div *ngIf="isDebug">
  <hr/>
  {{ info }}<br/>
  {{ currentSource | json }}
  <div>
    Definitions:
    <small class="tl-debug">{{ definitions | json }}</small>
  </div>
  <div>
    Sources:
    <small class="tl-debug">{{ sources | json }}</small>
  </div>
  <div>
    Plus:
    <small class="tl-debug">{{ sourcesPlus | json }}</small>
  </div>
</div>
